import React from "react";
import { Languages } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";
import { Lang } from "@/i18n/translations";

// Compact language selector (German / English). Persists via i18n context.
export const LanguageToggle: React.FC<{ testId?: string }> = ({ testId = "language-toggle" }) => {
  const { lang, setLang } = useI18n();
  const langs: Lang[] = ["de", "en"];
  return (
    <div
      data-testid={testId}
      className="inline-flex items-center gap-1 rounded-full p-1"
      style={{ background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.1)" }}
    >
      <Languages size={13} className="ml-1 text-slate-500" />
      {langs.map((l) => {
        const active = l === lang;
        return (
          <button
            key={l}
            data-testid={`language-${l}-btn`}
            onClick={() => setLang(l)}
            className={`rounded-full px-2.5 py-1 font-mono text-[10px] uppercase tracking-widest transition ${
              active ? "text-[#1a1204]" : "text-slate-400 hover:text-slate-200"
            }`}
            style={active ? { background: "linear-gradient(135deg,#FDE68A,#F59E0B)" } : {}}
          >
            {l}
          </button>
        );
      })}
    </div>
  );
};
